module.exports = __webpack_public_path__ + "img/3.f0000a56.png";